import { VersionedSerializer } from '@app/core/versionedSerializer/versionedSerializer';

const CURRENT_VERSION = 1;
const serializer = new VersionedSerializer<FavoritePayment>(CURRENT_VERSION);

/**
 * Serialize payment to string.
 * @param payment Favorite payment.
 * @returns Serialized string.
 */
export const writePayment = (payment:FavoritePayment): string => serializer.serialize(payment);

export const readPayment = (saved: string): FavoritePayment => serializer.deserialize(saved);

export class FavoritePayment {
  id: number;

  title: string;

  channelId: string;

  fromAccountId: number;

  toAccountId: number;

  amount: number;

  transferType: string;

  memo: string;

  fee: boolean;

  constructor() {
    this.id = 0;
    this.title = '';
    this.channelId = '';
    this.fromAccountId = 0;
    this.toAccountId = 0;
    this.amount = 0;
    this.transferType = '';
    this.memo = '';
    this.fee = false;
  }
}
